import React from 'react';
import DataResource from './../../../common/v4/DataResource'
import Panel from './../../../common/layout/Panel'


function getPercentageComponent(value) {
    return <>{parseFloat(value).toFixed(2)} %</>
}

export default class extends React.Component {

    

    render () {
        const today = new Date();
        const data = {
            url: '/admin/reports/voice/summary',
            limit: 50,
            offset: 0,
            filter: {},
            datalen: 0,
            datarows: [],
            servermeta: [],
            loading: false,
            userFilterAdvanced: true,
            userfilter:
            [
                {
                    source: 'start_time',
                    label: 'Date',
                    type: 'date_range',
                    default: {
                        'from' : new Date(today.getFullYear(), today.getMonth(), today.getDate(), 0, 0, 0),
                        'to': new Date(today.getFullYear(), today.getMonth(), today.getDate(), 23, 59, 59)
                    }
                },
                {
                    source: 'group_by_period',
                    label: 'Group by Period',
                    type: 'select',
                },
            ],
            metadata:[
                    {
                        label: 'id',
                        source: 'ID',
                        type: 'primary',
                        visible: false
                    },
                    {
                        label: 'Period',
                        source: 'period',
                        type: 'string',
                    },
                    {
                        label: 'Calls',
                        source: 'calls',
                        type: 'text'
                    },
                    {
                        label: 'Duration',
                        source: 'duration',
                        type: 'time'
                    },
                    {
                        label: 'ASR',
                        source: 'asr',
                        type: 'component',
                        component: getPercentageComponent
                    },
                    {
                        label: 'ACD',
                        source: 'acd',
                        type: 'time'
                    },
                    
                ]
            }
        return (
            <Panel title = "Voice Summary Report">
                <DataResource
                    data = {data}
                    {...this.props} 
                />
            </Panel>
        )
    }
}
